import Axios, * as others from 'axios';
import React, { Component,useEffect,useState } from "react";
import URL from '../../Environment';
import './calendar.css';

const CalendarTable = () => {

  const [data, setData] = useState([]);
  const [calendarYear, setDataYear] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

  const fetchData = async () => {
    // try {

      Axios.get(URL + 'api/Calendar/GetCalendar').then((response) => {
        const res = response.data.calendar;
        //console.log(res);
        if (Array.isArray(response.data.calendar)) {
          setData(response.data.calendar);
          setDataYear(response.data.year);
        } else {
          //console.error('Response data is not an array', response.data);
          setError('Data is not in the expected array format');
        }
        setLoading(false);   

      }).catch((error) => {
        setError(error);
        setLoading(false); 

      });
  };

  // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
  fetchData();

  // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
  return () => {
    // ทำการคืนการทำงานที่ต้องการ (cleanup)
    //console.log('Component unmounted');
  };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="col-md-9 col-sm-9 mb-sm-50">
      {/* Section title */}
      <h2 className="title-section mt-0 mb-0">
        <span>ปฏิทินสหกรณ์ ปี {calendarYear}</span>
      </h2><br/>
      {/* Divider */}
      <div className="divider gray left mt-20 mb-25"></div>
      
      {/* Table */}
      <table className="table table-bordered table-striped table-condensed table-hover">
        <thead>
          <tr style={{ color: "#ffffff", backgroundColor: "#3f5797" }}>
            <th style={{ textAlign: "center" }} rowSpan="2">เดือน</th>
            <th style={{ textAlign: "center" }} rowSpan="2">วันประชุม<br />ประจำเดือน</th>
            <th style={{ textAlign: "center" }} colSpan="2">ครั้งที่ 1</th>
            <th style={{ textAlign: "center" }} colSpan="2">ครั้งที่ 2</th>
            <th style={{ textAlign: "center" }} colSpan="2">วันจ่ายเงินกู้</th>
          </tr>
          <tr style={{ color: "#ffffff", backgroundColor: "#3f5797" }}>
            <th style={{ textAlign: "center" }}>ปิดรับเอกสารเงินกู้</th>
            <th style={{ textAlign: "center" }}>ประชุมเงินกู้</th>
            <th style={{ textAlign: "center" }}>ปิดรับเอกสารเงินกู้</th>
            <th style={{ textAlign: "center" }}>ประชุมเงินกู้</th>
            <th style={{ textAlign: "center" }}>ต้นเดือน</th>
            <th style={{ textAlign: "center" }}>กลางเดือน</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td style={{ textAlign: "center" }}>{item.month}</td>
              <td style={{ textAlign: "center" }}>{item.meetingdate}</td>
              <td style={{ textAlign: "center" }}>{item.first_loanformclose}</td>
              <td style={{ textAlign: "center" }}>{item.first_meetingloan}</td>
              <td style={{ textAlign: "center" }}>{item.second_loanformclose}</td>
              <td style={{ textAlign: "center" }}>{item.second_meetingloan}</td>
              <td style={{ textAlign: "center" }}>{item.loanpay_beginning}</td>
              <td style={{ textAlign: "center" }}>{item.loanpay_middle}</td>
            </tr>
          ))}
          <tr>
            <td style={{ textAlign: "center", color: "red" }} colSpan="8">
              ปิดรับเอกสารเงินกู้ทุกวันที่ 1 และ 15 ยกเว้นเงินกู้เพื่อเหตุฉกเฉิน
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CalendarTable;